import React from 'react';
import pluralize from 'pluralize';
import EmptyState from 'shared/empty_state';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { NonBasicCardStyling } from './util';
import { type PreviewEyeProps } from './preview_eye';

type CompanyDetails = {
  companyName: string,
  numberOfLeads: number
}
export type Props = {
  leadCountByCompanyName: CompanyDetails[],
  preview: boolean,
  previewEye: PreviewEyeProps
}

export default function CompanyCard({ leadCountByCompanyName, preview, previewEye }: Props) {
  const additionalClasses = 'ds-border ds-border-light border-bottom-0 border-right-0 border-left-0';
  const totalLeads = leadCountByCompanyName.reduce((sum, c) => sum + c.numberOfLeads, 0);

  function contentForCard() {
    return (
      <>
        <div>
          {pluralize('Employee', totalLeads)} of {' '}
          <b>
            {leadCountByCompanyName.length} {pluralize('company', leadCountByCompanyName.length)}
          </b>{' '}
          have inquired about this listing.
        </div>
        <div className="overflow-scroll ds-border ds-border-light" style={{ maxHeight: '300px', borderRadius: '3px' }}>
          {leadCountByCompanyName.map((companyDetails, index) => (
            <div
              className={`d-flex justify-content-between align-items-center p-3 ${index > 0 ? additionalClasses : ''}`}
              key={companyDetails.companyName}
            >
              <b>{companyDetails.companyName}</b>
              <div className="ds-text-muted">
                {companyDetails.numberOfLeads} {pluralize('Lead', companyDetails.numberOfLeads)}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <div className={NonBasicCardStyling}>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="m-0 fw-normal">Companies</h4>
        { !preview && previewEye }
      </div>
      {leadCountByCompanyName.length > 0 ? contentForCard() :
        (
          <EmptyState
            bodyText="Waiting For Data..."
            header="No Companies to display"
            icon={faExclamationCircle}
            iconSize="3x"
            style={{ minHeight: '250px' }}
          />
        )
      }
    </div>
  );
}
